<template>
  <div>
    <Navbar />
    <div class="subNav">
      <div class="xcl-sub-nav">
        <div class="xcl-sub-nav-inner">
          <a class="sub-nav-item active" style="font-weight: 700; position: relative; left: 40px" href="#old-carousel" @click.prevent="scrollToSection('old-carousel')">XCL for Custom New Energy Parts</a>
          <a class="sub-nav-item sub-right" href="#Why" @click.prevent="scrollToSection('Why')">Why XCL</a>
          <a class="sub-nav-item sub-right" href="#Services" @click.prevent="scrollToSection('Services')">Services</a>    
          <a class="sub-nav-item sub-right" href="#Materials" @click.prevent="scrollToSection('Materials')">Materials & Surface Finishes</a>
        </div>
      </div>
    </div>

    <div class="main-page-content">
      <section class="fct-hero-im" id="old-carousel">
        <div class="hero-bg-wrap">
          <img src="@/assets/banner/background.png" alt="CNC Machining" class="hero-bg-img">
          <div class="hero-mask"></div>
        </div>
        <div class="container">
          <div class="content-block">
            <h1 class="hero-title">Manufacturing Components <br>for the Energy Industry</h1>
            <div class="desc">
              <p>Rapid Prototyping and On-Demand Production</p>
            </div>
            <ul class="feature-list">
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">No MOQ</span>
              </li>
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">Tight Tolerances: ±0.005mm</span>
              </li>
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">20+ surface FinishesOptions</span>
              </li>
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">50+ Metal & Plastic Material Options</span>
              </li>
            </ul>
            <div class="btn-group">
              <span class="btn btn-cnc-quote" @click="$router.push('/quote')">Get Instant Quote</span>
              <p class="text-small">All uploads files are safe and confidential</p>
            </div>
          </div>
        </div>
      </section>

      <section class="why-section" id="Why">
        <div class="container">
          <h2 class="section-title">Why Choose Us</h2>
          <div class="features-grid">
            <div class="feature-card">
              <div class="icon-wrapper">
                <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="#16bc9c" stroke-width="1.8">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M8 12l3 3 5-5"></path>
                </svg>
              </div>
              <h3 class="card-title">High Quality Parts</h3>
              <div class="card-text">
                <p>XCL specializes in custom manufacturing of industrial equipment parts that meet precise requirements. Our manufacturing capabilities enable us to produce industrial parts with tolerances as tight as +/- 0.001 inches.</p>
              </div>
            </div>

            <div class="feature-card">
              <div class="icon-wrapper">
                <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="#16bc9c" stroke-width="1.8">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 7 12 12 16 14"></polyline>
                </svg>
              </div>
              <h3 class="card-title">Fast Lead Time</h3>
              <div class="card-text">
                <p>Get quotes within minutes and parts within days! With high manufacturing skills and technical experience, our expert engineers will work to reduce cycle time by up to 50%.</p>
              </div>
            </div>

            <div class="feature-card">
              <div class="icon-wrapper">
                <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="#16bc9c" stroke-width="1.8">
                  <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
              </div>
              <h3 class="card-title">Engineering Support</h3>
              <div class="card-text">
                <p>Being an ISO 9001:2015 certified organization, we guarantee that your industrial equipment components are manufactured utilizing the most suitable materials and techniques, like CNC machining, sheet metal fabrication, die casting and more. </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="process-section">
        <div class="section-header">
          <h2>
            We Help From
            <span class="accent-line"></span>
            <br>
            Prototyping to Production
          </h2>

          <div class="stack-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke-width="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z" class="layer-top" />
              <path d="M2 17l10 5 10-5M2 12l10 5 10-5" class="layer-bottom" />
            </svg>
          </div>
        </div>

        <div class="process-container">
          <div class="process-grid">

            <div class="process-step left">
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512">
                  <path d="M0 0h512v512H0z" fill="none" />
                  <path fill="currentColor"
                    d="M131.782 119.952L9.004 73.91L132.82 29.975l122.391 44.778zm8 106.905c26.237-8.313 52.788-7.282 77.33 1.152l47.457-91.787V88.436l-124.787 45.697zM355.066 31.39l.222 369.168L512 334.235zm-123.15 202.97c31.642 17.544 55.334 43.138 58.915 81.61c-2.477 29.23-14.532 56.125-34.584 76.668c-21.463 21.988-50.444 34.6-79.51 34.6c-29.277 0-58.412-10.698-79.936-29.35c-22.145-19.19-34.42-44.913-34.634-72.5c.99-39.26 18.627-71.225 61.548-92.115v-99.188L0 87.693V251.7l67.156 30.67c-13 20.199-20.546 44.242-20.546 70.049c0 71.58 58.027 129.607 129.607 129.607c60.573 0 111.435-41.555 125.647-97.71l35.215 16.244l-.223-369.168z" />
                </svg>
              </div>

              <div class="step-content">
                <h3 class="step-title">
                  <span class="step-number">01</span>
                  Prototyping
                </h3>
                <p class="step-desc">
                  Bring your early-stage New Energy part designs to life with prototypes crafted from production-grade materials. Our process enables you to evaluate and optimize your designs, ensuring they are fully functional and ready for testing.
                </p>
                <ul class="step-features">
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Design and material iterations in the early stages</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Prototypes with production-grade materials</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Innovative models similar to the final component</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Fast proof of functionality</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="process-step right">
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path fill="currentColor"
                    d="m22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9c-2-2-5-2.4-7.4-1.3L9 6L6 9L1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4" />
                </svg>
              </div>

              <div class="step-content">
                <h3 class="step-title">
                  <span class="step-number">02</span>
                  Engineering Validation and Testing
                </h3>
                <p class="step-desc">
                  Refine your New Energy part prototypes with quick and easy changes after rigorous engineering testing and validation of performance standards. Our functional prototypes, designed to mimic the final product, provide you with a clear visual representation of your design, allowing for easy identification of any potential issues.
                </p>
                <ul class="step-features">
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Functional prototypes with unmatched accuracy</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Comprehensive design and engineering options</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Design optimization and material selection</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="process-step left">
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                  <path d="M0 0h16v16H0z" fill="none" />
                  <path fill="currentColor" d="M7 9a1 1 0 1 1 2 0a1 1 0 0 1-2 0" />
                  <path fill="currentColor" fill-rule="evenodd"
                    d="M11.207 2H4.793L2 4.793V14h12V4.793zm-7.5 2.5l1.5-1.5h5.586l1.5 1.5zM8 7a2 2 0 1 0 1.016 3.723l1.13 1.13l.708-.707l-1.13-1.13A2 2 0 0 0 8 7"
                    clip-rule="evenodd" />
                </svg>
              </div>

              <div class="step-content">
                <h3 class="step-title">
                  <span class="step-number">03</span>
                  Design Validation and Testing
                </h3>
                <p class="step-desc">
                  Evaluate the performance, functionality, and aesthetics of your New Energy part product with precision. Save valuable time and resources by making design improvements during the prototype stage. Our expert design team provides in-depth feedback on the manufacturing feasibility of your prototypes, helping you assess their performance and appearance.
                </p>
                <ul class="step-features">
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Quality prototypes for life-cycle testing</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Functionality and aesthetic assessment</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Surface finishing optimization and validation</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="process-step right">
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path fill="currentColor"
                    d="M16.65 20.44H16v-2.37a3.07 3.07 0 0 0-6.14 0v2.37h-.64a1.5 1.5 0 0 0-1.5 1.5v1.56a.5.5 0 0 0 .5.5h9.43a.5.5 0 0 0 .5-.5v-1.56a1.5 1.5 0 0 0-1.5-1.5M13 19.1a1.06 1.06 0 0 1 0-2.1a1.06 1.06 0 1 1 0 2.11Z" />
                  <path fill="currentColor"
                    d="M23.92 8.81a4.32 4.32 0 0 0-4.13-3.09A4.2 4.2 0 0 0 18 6.1l-2.26-2.32A3 3 0 0 0 11.46.34A3 3 0 0 0 10 2.17L3.72 7a3.2 3.2 0 0 0-1.93.35a3.29 3.29 0 0 0 1.84 6.19l4.76 4.89V18A4.54 4.54 0 0 1 10 14.52L6.52 11a3.25 3.25 0 0 0 0-1.55l4.87-3.85a3 3 0 0 0 2.33.27l2.24 2.26a4.2 4.2 0 0 0-.45 1.9a4.31 4.31 0 0 0 3.21 4.17a1.2 1.2 0 0 0 .32 0a1.25 1.25 0 0 0 .31-2.46a1.81 1.81 0 1 1 2.2-2.26a1.25 1.25 0 1 0 2.39-.7Zm-20.61 2.5a1.05 1.05 0 1 1 1.06-1.05a1 1 0 0 1-1.06 1.05m9.54-7.22A1.1 1.1 0 1 1 14 3a1.09 1.09 0 0 1-1.15 1.09" />
                </svg>
              </div>

              <div class="step-content">
                <h3 class="step-title">
                  <span class="step-number">04</span>
                  Production Validation and Testing
                </h3>
                <p class="step-desc">
                  Streamline your designs for large-scale production with our production-grade manufacturing capabilities and expert quality control. Gain valuable insight into your product design with expert feedback from our technical team. This allows you to evaluate the manufacturability and suitability of your New Energy part and make final refinements for a streamlined production process.
                </p>
                <ul class="step-features">
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Agile and efficient low-volume production solutions</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">In-depth verification of manufacturing methods</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Top-quality precision parts with tight tolerances</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Production-grade design changes</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="process-step left">
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48">
                  <path d="M0 0h48v48H0z" fill="none" />
                  <g fill="none" stroke="#000" stroke-linejoin="round" stroke-width="4">
                    <path d="M44 14L24 4L4 14V34L24 44L44 34V14Z" />
                    <path stroke-linecap="round" d="M4 14L24 24" />
                    <path stroke-linecap="round" d="M24 44V24" />
                    <path stroke-linecap="round" d="M44 14L24 24" />
                    <path stroke-linecap="round" d="M34 9L14 19" />
                  </g>
                </svg>
              </div>

              <div class="step-content">
                <h3 class="step-title">
                  <span class="step-number">05</span>
                  Mass Production
                </h3>
                <p class="step-desc">
                  Effortlessly move into mass production with the swift delivery of end-use parts and the seamless integration of your quality standards into XCL's manufacturing process. Take your custom New Energy part manufacturing to new heights with our cutting-edge manufacturing techniques. Our team of experts works to ensure your products meet quality and performance requirements, keeping costs low and lead times short.
                </p>
                <ul class="step-features">
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">High-quality, production-ready components</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Precision machining with tight tolerances</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Unmatched post processing operations</span>
                  </li>
                  <li>
                    <span class="check-icon">✓</span>
                    <span class="text-content">Comprehensive quality inspection control system</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      <New_Services id="Services"/>
      <New_Materials_and_Finishes id="Materials"/>
      <New_Applications/>
      <INDUSTRIES_SERVE/>
      <New_together/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue';
import Footer from '@/views/front/components/Footer.vue';
import Navbar from '@/views/front/components/Nav.vue';
import INDUSTRIES_SERVE from '@/views/front/components/INDUSTRIES_SERVE.vue';
import New_Services from '@/views/front/Industries/New Energy/components/New_Services.vue';
import New_Materials_and_Finishes from '@/views/front/Industries/New Energy/components/New_Materials_and_Finishes.vue';
import New_Applications from '@/views/front/Industries/New Energy/components/New_Applications.vue';
import New_together from '@/views/front/Industries/New Energy/components/New_together.vue';

export default {
  name: 'New_Energy',
  components: { Navbar, Footer,INDUSTRIES_SERVE,New_Services,New_Materials_and_Finishes,New_Applications,New_together},
  setup() {
      
    const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (!element) return;

      const isMobile = window.innerWidth <= 1024;
      // 匹配隐藏二级导航后的高度判断
      const navbarHeight = isMobile ? 65 : (65 + 76); 
      const elementPosition = element.offsetTop - navbarHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }

    const handleImageError = (e) => {
      e.target.src = "https://via.placeholder.com/520x260/eeeeee/66666?text=Image+Error";
    };

    return {
      handleImageError,
      scrollToSection
    };
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

/* 二级导航 */
.subNav {
  width: 100%;
  height: 76px;
  background: #fff;
  border-bottom: none;
  position: fixed;
  top: 65px;
  left: 0;
  z-index: 998;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
}

.xcl-sub-nav {
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 1px rgba(78, 78, 78, .05);
  position: relative;
  z-index: 50 !important;
  height: 100%;
  top: 0;
}

.xcl-sub-nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  height: 78%;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 20px;
}

.sub-nav-item {
  font-size: 16px;
  color: #505050;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
}

.active:hover {
  color: #0e957b;
}

.sub-right {
  position: relative;
  right: -507px; /* 保留原版距离以贴合当前导航项字宽 */
  transition: color .3s;
}

.sub-right:hover {
  color: #0e957b !important;
}

.sub-right::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: #0e957b;
  transition: all .3s;
}

.sub-right:hover::after {
  width: 100%;
}

/* section 样式 (同步标准排版) */
.fct-hero-im {
  position: relative;
  width: 100%;
  min-height: 525px;
  padding: 60px 0;
  overflow: hidden;
  background: #ffffff;
}

.hero-bg-wrap {
  position: absolute;
  top: 0;
  right: 280px; 
  width: 65%;
  height: 100%;
  z-index: 1;
}

.fct-hero-im .container {
  padding: 0 608px 0 0; 
  max-width: 1200px;
  margin: 0 auto;
  position: relative; 
  z-index: 10;      
}

.content-block {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}

.hero-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.9;
  display: block;
}

.hero-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 70%;
  height: 100%;
  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.95) 40%, rgba(255, 255, 255, 0) 100%);
  z-index: 2;
}

.hero-title {
  font-size: 42px;
  font-weight: 600;
  color: #333333;
  line-height: 1.15;
  margin-bottom: 1.5rem;
  font-family: inherit;
  white-space: nowrap;
  overflow: visible;
}

.desc p {
  font-size: 1rem;
  color: #555555;
  line-height: 1.7;
  margin-bottom: 12px;
  font-family: inherit;
  font-weight: 500;
}

.feature-list {
  list-style: none;
  margin: 0 0 30px 0;
  padding: 0;
}

/* 列表及图标对齐核心样式 (同步彻底解决错位) */
.feature-item {
  display: flex;
  align-items: flex-start; 
  font-size: 16px;
  color: #505050;
  margin-bottom: 12px; 
  line-height: 1.5; 
  font-weight: 500;
}

.check-icon {
  color: #16bc9c;
  font-weight: bold;
  margin-right: 12px;
  font-size: 20px;
  flex-shrink: 0; 
  line-height: 24px; 
}

.text-content {
  flex: 1; 
}

.btn-group {
  margin: 30px 0;
}

.btn-cnc-quote {
  display: inline-block;
  background-color: #16bc9c;
  color: #ffffff;
  font-size: 1rem;
  padding: 14px 29px;
  border-radius: 4px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: color 0.4s;
}

.btn-cnc-quote::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: #027062;
  transition: all 0.4s;
  z-index: -1;
}

.btn-cnc-quote:hover::before {
  left: 0;
}

.text-small {
  font-size: 0.75rem;
  color: #17202a;
  margin-top: -3px;
  font-weight: 600;
}

/* ================= 1024px 中等屏幕适配及隐藏二级导航 ================= */
@media (max-width: 1024px) {
  .subNav {
    display: none !important;
  }
  
  .main-page-content {
    margin-top: -45px;
  }

  .content-block {
    width: 100%;
    text-align: left; 
  }
  .hero-title {
    font-size: 32px; 
    white-space: normal;
  }
  .desc p {
    font-size: 1.1rem;
  }
  .btn-cnc-quote {
    font-size: 1.2rem;
    padding: 14px 30px;
  }
  .hero-bg-wrap {
    width: 100%;
    right: 0;
  }
  .hero-mask {
    width: 100%;
    background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.4) 100%);
  }
  .fct-hero-im .container {
    padding: 0 40px; 
  }
}

/* ================= 移动端列表文字居中问题 (768px 及以下生效) ================= */
@media (max-width: 768px) {
  .container {
    padding: 0 20px !important; 
  }
  
  .fct-hero-im .container {
    padding: 0 20px !important;
  }

  .feature-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start; 
  }

  .feature-item {
    justify-content: flex-start; 
    width: 100%;
  }

  .text-content {
    flex: 1; 
    text-align: left; 
    max-width: 100%; 
  }
}

.why-section {
  padding: 80px 0;
  background: #ffffff;
}

.why-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin-bottom: 48px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.feature-card {
  padding: 40px 32px;
  text-align: center;
  border-right: 1px solid #e5e7eb;
}

.feature-card:last-child {
  border-right: none;
}

.icon-wrapper {
  width: 64px;
  height: 64px;
  margin: 0 auto 24px;
}

.feature-icon {
  width: 100%;
  height: 100%;
}

.card-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
}

.card-text {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.card-text p {
  margin: 0 0 12px;
}

.card-text p:last-child {
  margin-bottom: 0;
}

@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
  .feature-card {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
  .feature-card:last-child {
    border-bottom: none;
  }
}

.cert-section {
  background-color: #222222 !important;
  height: 212px !important;
  display: flex;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
}

.cert-list {
  display: flex;
  justify-content: space-between !important;
  align-items: flex-start !important;
  flex-wrap: nowrap !important;
  width: 100%;
  gap: 18px;
}

.cert-item {
  display: flex;
  align-items: flex-start !important;
}

.cert-text {
  display: flex;
  flex-direction: column;
  gap: 4px !important;
  text-align: center !important;
}

.text-line {
  font-size: 16px !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  font-family: inherit !important;
  white-space: nowrap !important;
}

@media (max-width: 992px) {
  .cert-list {
    flex-wrap: wrap !important;
    gap: 20px !important;
    justify-content: flex-start !important;
  }
  .cert-item {
    width: 48%;
  }
  .cert-section {
    height: auto !important;
    padding: 30px 20px;
  }
}

.process-section {
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.section-header {
  max-width: 1200px;
  margin: 0 auto;
  padding: 70px 30px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-header h2 {
  font-size: 2.6rem;
  font-weight: 700;
  color: #111;
  line-height: 1.3;
}

.accent-line {
  display: inline-block;
  width: 50px;
  height: 4px;
  background: #0e957b;
  margin: 0 8px;
  vertical-align: middle;
}

.stack-icon svg {
  width: 90px;
  height: 90px;
}

.layer-top {
  stroke: #038372;
}

.layer-bottom {
  stroke: #16bc9c;
}

.process-container {
  width: 100%;
  background: #fff;
  padding: 100px 0;
}

.process-grid {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 120px;
  row-gap: 40px;
}

.process-step {
  display: flex;
  align-items: flex-start;
  gap: 28px;
}

.process-step.left {
  grid-column: 1;
}

.process-step.right {
  grid-column: 2;
  margin-top: 140px;
}

.step-icon {
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  color: #1b1b1b;
}

.step-icon svg {
  width: 100%;
  height: 100%;
}

.step-content {
  max-width: 520px;
}

.step-title {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.25;
  color: #111;
  margin-bottom: 22px;
}

.step-number {
  color: #16bc9c;
  margin-right: 10px;
}

.step-desc {
  font-size: 1rem;
  line-height: 1.9;
  color: #333;
  margin-bottom: 24px;
}

.step-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* 修改：将 align-items 改为 flex-start 实现第一行文字对齐 */
.step-features li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  font-size: 1rem;
  line-height: 1.5; /* 补充一点行高让视觉更居中 */
  color: #222;
}

/* 新增：向下微调一下打勾图标，让它看起来与首行文字完全水平居中 */
.step-features .check-icon {
  margin-top: 2px;
}

@media (max-width: 992px) {
  .process-grid {
    column-gap: 60px;
  }
  .process-step.right {
    margin-top: 80px;
  }
}

@media (max-width: 768px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 50px 20px 40px;
  }
  .section-header h2 {
    font-size: 2rem;
  }
  .process-container {
    padding: 70px 0;
  }
  .process-grid {
    grid-template-columns: 1fr;
    row-gap: 70px;
    padding: 0 20px;
  }
  .process-step {
    flex-direction: column;
    gap: 20px;
  }
  .process-step.right {
    margin-top: 0;
    grid-column: auto;
  }
  .step-title {
    font-size: 1.6rem;
  }
  .step-content {
    max-width: 100%;
  }
}
</style>